module.exports = __webpack_public_path__ + "media/img/automated-testing/benefits/benefits-img7-f93ed06f636531cf2ee6cf02ecd36391.svg";